import { RadioGroup as BaseRadioGroup } from '@base-ui/react/radio-group'
import { twMerge } from 'tailwind-merge'
import { useFieldRequired } from '../field/nested/context'
import { RadioGroupIndicator } from './nested/indicator'
import { RadioGroupItem } from './nested/item'
import type { PartProps } from '../../lib/part-props'

interface RadioGroupRootProps extends PartProps<BaseRadioGroup.Props> {
  className?: string
}

/**
 * A pick-one set. One tab stop for the group, arrow keys move and select. Sit it in a `Field` and
 * each `RadioGroup.Item` in a `Field.Item` with its `Field.Label`, so the whole row is the hit target.
 */
function RadioGroup({ className, children, required, ...props }: RadioGroupRootProps) {
  return (
    <BaseRadioGroup
      required={useFieldRequired(required)}
      className={twMerge('flex flex-col gap-3', className)}
      {...props}
    >
      {children}
    </BaseRadioGroup>
  )
}

RadioGroup.Item = RadioGroupItem
RadioGroup.Indicator = RadioGroupIndicator

export { RadioGroup }
